@let selectedIds = selectedGroupIds$ | async;
@let selected = selectedGroups$ | async;

<mat-form-field class="w-100 loren-form-field">
  <mat-label>{{ "operations.select_hierarchy" | transloco }}</mat-label>
  <mat-chip-grid #chipList>
    @for (group of selected; track group) {
      <mat-chip-row
        [removable]="true"
        (removed)="remove(group.id)">
        {{ group.name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }

    <input [formControl]="query"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [disabled]="isDisabled"
      />
    <button matSuffix mat-icon-button (click)="openHierarchySelectionDialog()">
      <mat-icon color="accent">account_tree</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-autocomplete #auto="matAutocomplete"
    [hideSingleSelectionIndicator]="true"
    [autoActiveFirstOption]="true">
    @for (item of autocompleteItems$ | async; track item.id) {
      <mat-option (onSelectionChange)="handleSelect(item)" [disabled]="selectedIds.includes(item.id)">
        {{ item.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
